import { authService } from '@/services/authService';

/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  
  // 定义用户角色
  const userRole = currentUser?.role || null;
  const isAdmin = userRole === 'admin';
  const has = (permission: string) => isAdmin || authService.hasHeadOfficePermission(permission);
  const headOfficeMenuPermissions = [
    'ho.members.retail.view',
    'ho.members.staff_trade.view',
    'ho.points_audit.view',
    'ho.giftcards.view',
    'ho.vouchers.view',
    'ho.settings.view',
  ];
  
  return {
    // 是否管理员
    canAdmin: isAdmin,
    canAccessHeadOfficeManagement: isAdmin || authService.hasAnyHeadOfficePermission(headOfficeMenuPermissions),
    canAccessRetailCustomers: has('ho.members.retail.view'),
    canAccessStaffTradeMembers: has('ho.members.staff_trade.view'),
    canAccessHeadOfficeMemberDetails: isAdmin || authService.hasAnyHeadOfficePermission([
      'ho.members.retail.view',
      'ho.members.staff_trade.view',
      'ho.points_audit.view',
    ]),
    canAccessGiftCards: has('ho.giftcards.view'),
    canAccessVouchers: has('ho.vouchers.view'),
    canAccessHeadOfficeSettings: has('ho.settings.view'),
    canAccessUserAppManagement: has('ho.user_app.posters.view'),
    
    // 是否能访问员工管理
    canAccessStaffManagement: has('ho.staff.view'),
    
    // 是否能访问通信统计
    canAccessStatistics: has('ho.communication.view'),

    // 是否能访问人工积分审查
    canAccessPointsAudit: has('ho.points_audit.view'),
    
    // 基础能力 - 所有登录用户
    isUser: !!currentUser,
  };
}
